import React, { useState, useEffect } from "react";
import Tooltip from "@mui/material/Tooltip";

const IdealCandidateButton = ({ setOpenIdealCandidates = () => { }, job }) => {
  const [disabled, setDisabled] = useState(false);
  const [remaining, setRemaining] = useState(0);
  const cooldownTime = 120; // seconds (2 minutes)
  const jobKey = `ideal_candidate_${job?._id || "unknown"}`;

  const handleClick = () => {
    const now = Date.now();
    // sessionStorage.setItem(jobKey, now.toString());
    // setDisabled(true);
    setRemaining(cooldownTime);
    setOpenIdealCandidates(true);
  };

  // On mount, check if cooldown is still active
  // useEffect(() => {
  //   const storedTime = sessionStorage.getItem(jobKey);
  //   if (storedTime) {
  //     const elapsed = Math.floor(
  //       (Date.now() - parseInt(storedTime, 10)) / 1000
  //     );
  //     if (elapsed < cooldownTime) {
  //       setRemaining(cooldownTime - elapsed);
  //       setDisabled(true);
  //     } else {
  //       sessionStorage.removeItem(jobKey);
  //       sessionStorage.removeItem(`${jobKey}_opened`);
  //     }
  //   }
  // }, [jobKey]);

  // Handle countdown and re-enable after timeout
  useEffect(() => {
    let timer;
    if (remaining > 0) {
      timer = setInterval(() => {
        setRemaining((prev) => prev - 1);
      }, 1000);
    } else if (remaining === 0 && disabled) {
      setDisabled(false);
      sessionStorage.removeItem(jobKey);
    }
    return () => clearInterval(timer);
  }, [remaining, disabled, jobKey]);

  const tooltipMessage = disabled
    ? `Please wait approximately ${Math.ceil(remaining / 60)} minute${remaining > 60 ? "s" : ""
    } before attempting again.`
    : "Click to view Ideal Candidate";

  return (
    <div className="tw-relative tw-inline-block mt-3 mt-lg-0">
      <Tooltip title={tooltipMessage} arrow placement="top">
        <span>
          <button
            className={`small-button-cotain-view-all ${disabled ? "tw-opacity-50 tw-cursor-not-allowed" : ""
              }`}
            onClick={!disabled ? handleClick : undefined}
            disabled={disabled}
          >
            Ideal Candidates
          </button>
        </span>
      </Tooltip>
    </div>
  );
};

export default IdealCandidateButton;
